import { useMutation } from "@tanstack/react-query";
import { submitLead } from "./submitLead.ts";
import type { SubmitLeadPayload } from "../../../lib/schemas/index.ts";

export function useSubmitLead() {
  return useMutation({ mutationFn: (payload: SubmitLeadPayload) => submitLead(payload) });
}
